module.exports = __webpack_public_path__ + "img/Layer 3.44212e24.svg";